import React from 'react';
import { Slider, Icon } from 'antd';
import { connect } from 'react-redux';
import { startSetMapOpacity } from '../actions/globalState';

export class OpacitySlider extends React.Component {

  onOpacityChange = (value) => {
    this.props.startSetMapOpacity(value/100);
  }

  render() {
    return (
      <div className="icon-wrapper">
        <h3>Layer transparency </h3>
        <Icon type="appstore-o" className="left" />
        <Slider
          value={this.props.opacity*100}
          onChange={value => this.onOpacityChange(value)}
        />
        <Icon type="appstore" />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  opacity: state.globalState.opacity
});

const mapDispatchToProps = (dispatch) => ({
  startSetMapOpacity: (text) => dispatch(startSetMapOpacity(text))
});

export default connect(mapStateToProps, mapDispatchToProps)(OpacitySlider);


// WEBPACK FOOTER //
// ./src/components/OpacitySlider.js